import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SchemaPropertyNode, propertyFormModel, modalDialogEvent } from "../../../../../components/SchemaPropertyNode";
import { NgbModal, ModalDismissReasons, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { SchemaPropertyEditComponent } from "../schema-property-edit/schema-property-edit.component";


@Component({
  selector: 'app-entity-schema-node',
  template: `<mat-expansion-panel  class="mat-expansion-panel left-{{propertyNode.nodeLevel}}">
  <mat-expansion-panel-header [ngClass]="{'not-scalar': propertyNode.isNotScalar() }">


    <mat-panel-title>
      <span>{{propertyNode.propName}}</span>
      <span *ngIf="propertyNode.isRequired" class="required"><strong>*</strong></span>
      <span>:</span>
      <span>{{propertyNode.propType}}</span>
      
     <i class="addProperty fa fa-plus-square-o" title="add Property" (click)="openPropertyEditViewModal()" style="font-size:24px;color:green"></i>
      <i class="fa fa-minus-square-o" *ngIf="!propertyNode.isRootNode()" title="delete property" (click)="deleteNode()" style="font-size:24px;color:red"></i>
    
    </mat-panel-title>

      <div>
      </div>
  </mat-expansion-panel-header>

  <div class="propAttibutes">
    <div class="propAttibute" *ngFor="let propAttibute of propertyNode.propAttributes">
      <span>{{propAttibute.key}}</span>
      <span>:</span>
      <span>{{propAttibute.value}}</span>
    </div>
    <div class="propAttibute">
      <span>Required</span>
      <span>:</span>      
      <input type="checkbox" name="Required" class="regular-checkbox"  [checked]="propertyNode.isRequired" (change)="propertyNode.isRequired=!propertyNode.isRequired">
    </div>
  </div>
</mat-expansion-panel>

<app-entity-schema-node (deleteEvent)="onDeleteNodeEvent($event)" *ngFor="let property of propertyNode.properties" [propertyNode]="property.value"></app-entity-schema-node>`,
  styles: [`.mat-expansion-panel[_ngcontent-c25]{margin-bottom:1px}.mat-expansion-panel:not([class*=mat-elevation-z]){-webkit-box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.mat-expansion-panel{-webkit-transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);transition:box-shadow 280ms cubic-bezier(.4,0,.2,1),-webkit-box-shadow 280ms cubic-bezier(.4,0,.2,1);-webkit-box-sizing:content-box;box-sizing:content-box;display:block;margin:0;-webkit-transition:margin 225ms cubic-bezier(.4,0,.2,1);transition:margin 225ms cubic-bezier(.4,0,.2,1);background:#fff;color:rgba(0,0,0,.87)}.mat-expansion-panel-header{height:48px!important}.mat-expansion-panel-header.mat-expanded.not-scalar,.mat-expansion-panel-header.not-scalar{background:#87ceeb}.mat-expansion-panel-header-title{color:rgba(0,0,0,.87)}.mat-expansion-panel-header.not-scalar .mat-expansion-panel-header-title i.addProperty{display:block}.mat-expansion-panel-header .mat-expansion-panel-header-title i.addProperty{display:none}.mat-expansion-panel-header-title i,.mat-expansion-panel-header-title span{margin-left:5px}.propAttibutes{color:#868989;background-color:#efefef;border-radius:2px;padding:6px 16px;cursor:pointer;font-size:13px;margin-top:10px}.propAttibute{color:#ff9405;margin:5px}.propAttibute input,.propAttibute span{font-family:'Roboto Mono',Menlo,"Bitstream Vera Sans Mono","DejaVu Sans Mono",Monaco,Consolas,monospace}.left-1{margin-left:15px!important}.left-2{margin-left:30px!important}.left-3{margin-left:45px!important}.left-4{margin-left:60px!important}.left-5{margin-left:75px!important}.left-6{margin-left:90px!important}.left-7{margin-left:105px!important}.left-8{margin-left:120px!important}.regular-checkbox{-webkit-appearance:none;background-color:#fafafa;border:1px solid #cacece;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05);padding:7px;border-radius:3px;display:inline-block;position:relative;margin-bottom:-3px}.required{color:red}.regular-checkbox:active,.regular-checkbox:checked:active{-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 1px 3px rgba(0,0,0,.1)}.regular-checkbox:checked{background-color:red;border:1px solid red;-webkit-box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);box-shadow:0 1px 2px rgba(0,0,0,.05),inset 0 -15px 10px -12px rgba(0,0,0,.05),inset 15px 10px -12px rgba(255,255,255,.1);color:#99a1a7}`]
  
})
export class EntitySchemaNodeComponent implements OnInit, modalDialogEvent {

  @Input() propertyNode: SchemaPropertyNode;
  @Output() deleteEvent:EventEmitter<SchemaPropertyNode>=new EventEmitter<SchemaPropertyNode>();
  
  
  propertyFormModel: propertyFormModel;
  constructor(private modalService: NgbModal) { }

  ngOnInit() {
  }
  deleteNode(){
    this.deleteEvent.emit(this.propertyNode);
  }
  onDeleteNodeEvent(property:SchemaPropertyNode){
    var index = this.propertyNode.properties.findIndex(item=>item.key===property.propName);
        if(index>-1){
           this.propertyNode.properties.splice(index,1);
        }
  }
  openPropertyEditViewModal() {
    const modalInstance= this.modalService.open(SchemaPropertyEditComponent,{ size:"lg", backdrop:"static"});
    modalInstance.componentInstance.propertyNode=this;
    this.propertyFormModel=new propertyFormModel();
    this.propertyFormModel.formType=this.propertyNode.propType.toLowerCase();
    modalInstance.componentInstance.propertyFormModel=this.propertyFormModel;
  }
  doClickAddProperty() {
    let schemaNode = new SchemaPropertyNode();
    schemaNode.nodeLevel = this.propertyNode.nodeLevel + 1;
    schemaNode.propName = this.propertyNode.propType === "array" ? this.propertyNode.properties.length.toString() : this.propertyFormModel.propName.toLowerCase();
    schemaNode.propType = this.propertyFormModel.propType;    
    schemaNode.propAttributes.push({ key: "description", value: this.propertyFormModel.description });
    schemaNode.isRequired=this.propertyFormModel.isRequeried;
    this.propertyNode.properties.push({ key: schemaNode.propName, value: schemaNode });

  }
  doActionOnSuccessEvent(args:any) {
    this.doClickAddProperty();
    this.propertyFormModel=new propertyFormModel();
  }
  doActionOnDismissEvent() {

  }

}
